/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>powerbi-report-container.component.ts</name>
///
/// <description>
/// A component that presents callstatus data
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>23 Aug 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 23Aug17 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import {Component, OnInit, Input, Output, EventEmitter} from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";
import {HostListener} from '@angular/core';
import { hydUtilService} from "../../../utils/hydUtils.service";
import {Accordion, AccordionTab, MenuItem} from "primeng/primeng";


import {MediatorService} from "../../../services/mediator.service";
import {MediatorEventLookup} from "../../../services/mediator-event-lookup.service";

import {CUIFeatureInterface} from  "../../../interfaces/cui-feature.interface";

import {TranslatedStringsService } from '../../../services/language.service';

 import  *   as pbi from 'powerbi-client';


import {
    App,
    Adapter,
    Addresses,
    AirMedia,
    AudioDevices,
    AudioVideoInputOutput,
    AutoUpdateMaster,
    Credentials,
    Background,
    Bluetooth,
    CustomBackground,
    Device,
    DeviceList,
    DevicesSearch,
    DeviceOperation,
    DeliveryStateEnum,
    DeviceApiService,
    DownstreamEdid,
    Ethernet,
    FusionSetup,
    FusionCloud,
    General,
    Hdmi,
    IPAddr,
    InputOutput,
    LicenseRegistry,
    Logo,
    MergeAction,
    OperationStateEnum,
    OperationEnum,
    Port,
    Scheduling,
    SIP,
    Settings as AVFSettings,
    Speedkey,
    Sntp,
    SystemVersions,
    SystemClock,
    RunTimeSettings,
    TimeOptions,
    USB,
    VideoDisplay,
    SFB,
    Preset,
    ConnectionDisplayOptions,
    ThirdPartyApplications,
    ZoomRoom,
    DeviceRequest
} from '../../../services/Crestron.HydrogenAPI.DeviceApi.service';

import {
    Background as GroupBackground,
    GroupApiService,
    Settings as GroupAVFSettings,
    GroupAPI,
    Group,
    Policy,
    GroupsSearch,
    GroupAPIRequest} from '../../../services/Crestron.HydrogenAPI.GroupApi.service';


import { DashboardAPIService, EmbeddedObjectType  } from '../../../services/Crestron.HydrogenAPI.DashboardTokenApi.service';
import { HydUser } from '../../../models/user';

declare let objectPath: any;
declare let jQuery: any;
declare let powerbi: any;


@Component({
    selector: "powerbi-report-container",
    templateUrl: "./powerbi-report-container.component.html"
})
export class PowerBiReportContainerComponent implements CUIFeatureInterface {


    private modelTypes: any;
    private modelDefault: string = "MERCURY";
    private modelType: string = this.modelDefault;
    private childGroups: Array<GroupAPI>;
    private allGroups: GroupAPI[];

    private  embedContainer:any;
    private reportFilters: Array<any>;

    private reportType: string;
    private reportTypes: Array<any> = [];
   
    private reportId: string;  
    private groupId: string;
    private reportToken: string; 
    private reportUrl: string;
   
    private reportTokenExpiration: number;

    private embeddedReport: pbi.Embed;
    private reportVisible: boolean =false;
    //RBAC
    private enableForm: boolean;


    private debugMode: boolean = false;
    private tabState  = new Array<boolean>();
    private status:any = [];
    private routeParamsSubscription: Subscription;
    private loaded: boolean = false;
    private lblLastCommunicated: string;
    private lblDashboard: string;
    private lblFullscreen: string;
    private debugModeToggleSubscription: Subscription;
    private busyLoading: any;
    private pushTimer: any;
    private pushTimerSubscription: Subscription; 
    private lblDeviceOnline: string;
    private lblDeviceOffline: string;
    private lblDeviceModel: string;
    private lblDeviceReport: string;
    private lblNoReports: string;

    private customerId: string;
    private statusClass: string;
    private statusText: string;
    private viewModel: any = null;
    private dashboardPermissions: Array<Report>;

    private loadReportTokenSubscription: Subscription;
    private loadDashboardPermissionsSubscription: Subscription;
    private allowed: boolean = true;

    constructor (
       private mediatorService: MediatorService,
       private i18n: TranslatedStringsService,
       private route: ActivatedRoute,
       private http: Http,
       private apiDashboardService: DashboardAPIService,
       private hydUser: HydUser,
    ) {

    }

    //----------------------------------------------------------
    //Implementations of Interface
    //----------------------------------------------------------

    //ngOnInit(){  };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };

    ngAfterViewChecked() { };


    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

        try {

            this.Start();

        }
        catch (e) {
            console.log("Error-->ngOnInit()");
        }

    }

    //----------------------------------------------------------
    //ngAfterViewInit
    //----------------------------------------------------------
    ngAfterViewInit() {

      

    }

    //----------------------------------------------------------
    //ngOnDestroy
    //----------------------------------------------------------
    ngOnDestroy() {


        try{

            this.stopReportTokenSubscription();
            this.stopRouteParamsSubscription();
            this.stopDashboardPermissionsSubscription();

        }
        catch(e) {
            console.log("Error-->ngOnDestroy()");
        }
    }


    //----------------------------------------------------------
    //ngOnChanges
    //----------------------------------------------------------
    ngOnChanges(changes: any) {

  }
    //----------------------------------------------------------
    //setupTimer
    //----------------------------------------------------------
    private setupTimer() {

      setInterval(function () {

        let embedContainer = jQuery('#embedContainer')[0];
        if (embedContainer) {
          let report = powerbi.get(embedContainer);
          if (report) {

            // Reload the displayed report
            report.refresh()
              .then(function (result) {

              })
              .catch(function (errors) {

              });

          }
        }

      }, 300000);

    }


  //-----------------------------------------------
  // subscribeToRouteParams
  //-----------------------------------------------
  protected subscribeToRouteParams() {

    this.stopRouteParamsSubscription();

    this.routeParamsSubscription = this.route.params
      .subscribe(params => {  

        this.customerId = params['customerId'];
        if (this.customerId) {

          let customerReport: Report = this.dashboardPermissions.find(permissions => permissions.reportName.includes(this.customerId.toUpperCase()));
          if (customerReport && customerReport.accounts && this.hydUser.AccountId) {
             
            let customerMatchingAcct: string = customerReport.accounts.find(accounts => accounts.includes(this.hydUser.AccountId));
            if (!customerMatchingAcct) {
                this.allowed = false;
            }
            else{ 
                this.allowed = true;
                this.setupTimer();
                this.reportId = customerReport.reportId;
                this.groupId = customerReport.groupId;
                this.reportType = customerReport.reportType; 
                //this.reportUrl = "https://app.powerbi.com/reportEmbed?reportId=" + this.reportId + "&groupId=" + this.groupId;
                this.reportUrl = "https://app.powerbi.com/" + this.reportType + "Embed?" + this.reportType + "Id=" + this.reportId + "&groupId=" + this.groupId;

                this.refreshData();

            }



          }
          

        }
      

      });


  }
  //-----------------------------------------------
  // stopRouteParamsSubscription
  //-----------------------------------------------
  protected stopRouteParamsSubscription() {

    if (this.routeParamsSubscription)
      this.routeParamsSubscription.unsubscribe();

  }

  //-----------------------------------------------
  // stopDashboardPermissionsSubscription
  //-----------------------------------------------
  protected stopDashboardPermissionsSubscription() {

    if (this.loadDashboardPermissionsSubscription)
      this.loadDashboardPermissionsSubscription.unsubscribe();

  }
    //----------------------------------------------------------
    //translate
    //----------------------------------------------------------
    translate() {

        try{
            this.lblNoReports = this.i18n.translate("no-dashboards");
            this.lblDeviceReport = this.i18n.translate("device-dashboard");
            this.lblDeviceModel = this.i18n.translate("device-modal");
            this.lblDeviceOnline = this.i18n.translate("device-status-online");
            this.lblDeviceOffline = this.i18n.translate("device-status-offline");
            this.lblLastCommunicated = this.i18n.translate("last-communicated");
            this.lblDashboard = this.i18n.translate("device-dashboard");
            this.lblFullscreen = this.i18n.translate("dashboard-fullscreen");
        }
        catch(e) {
            console.log("Error-->translate()");
        }
    }





    //-----------------------------------------------
    // stopRouteParamsSubscription
    //-----------------------------------------------
    private stopReportTokenSubscription() {

        if (this.loadReportTokenSubscription)
            this.loadReportTokenSubscription.unsubscribe();

    }



    //----------------------------------------------------------
    //Start
    //----------------------------------------------------------
    private Start() {

      try {

             
             this.translate();  
            
         
             //Get
              this.loadDashboardPermissionsSubscription = this.getDashboardPermissions().subscribe(data => {

                this.dashboardPermissions = data;
                this.subscribeToRouteParams();




              },
              err => {

              });
              this.UpdateBusyControl();

        }
        catch(e) {
            console.log("Error-->Start()");
        }

    };




    //-----------------------------------------------
    // refreshData
    //-----------------------------------------------
    private refreshData( ) {

      try {

       
            if (this.reportUrl) {
                this.loadReportTokenSubscription = this.getReportToken().subscribe(data => {

                  this.reportToken = JSON.parse(data).AccessToken;
                  this.reportTokenExpiration = Date.parse(JSON.parse(data).TokenExpiration);
                  this.loadReport();


                },
                err => {
                    console.log(err);


                    });

                this.UpdateBusyControl();
            }

        }
        catch(e) {
            console.log("Error-->refreshData()");
        }


    }


    //----------------------------------------------------------
    //getReportToken
    //----------------------------------------------------------
    private getReportToken(): Observable<any> {


      try {

        if (this.reportType === "dashboard") {
          return this.apiDashboardService.getPowerBIEmbedTokenByUser(EmbeddedObjectType.Dashboard, this.groupId, this.reportId, "");
        }
        else if (this.reportType === "report") {
          // return this.apiDashboardReportService.getPowerBIEmbedTokenByUser(this.reportId); 
          return this.apiDashboardService.getPowerBIEmbedTokenByUser(EmbeddedObjectType.Report, this.groupId, this.reportId, "");

        }

        //return this.apiDashboardService.getPowerBIEmbedTokenByUser(  this.reportId);
        // // return this.apiDashboardService.getPowerBIEmbedTokenByUserForDashboard(this.groupId, this.reportId);

        }
        catch (e) {
            return Observable.of(null);
        }

    }

    //----------------------------------------------------------
    //onFullscreenClick
    //----------------------------------------------------------
    private onFullscreenClick(event) {

        try {
          let embedContainer = jQuery('#embedContainer')[0];
          if (embedContainer) {
            let report = powerbi.get(embedContainer);
            report.fullscreen();
          }
        }
        catch (e) {
            console.log("Error-->onFullscreenClick()");
        }
    }

    //----------------------------------------------------------
    //keyDown
    //----------------------------------------------------------
    @HostListener('window:keydown', ['$event'])
    private keyDown(event: KeyboardEvent): void {

        try {
            const ESCAPE_KEYCODE = 27;
            if (event.keyCode ===  ESCAPE_KEYCODE) {
                let embedContainer = jQuery('#embedContainer')[0];
                let report = powerbi.get(embedContainer);
                report.exitFullscreen();
            }
        }
        catch (e) {
            console.log("Error-->onFullscreenClick()");
        }

    }



    //----------------------------------------------------------
    //loadReport
    //----------------------------------------------------------
    private loadReport() {
        try {

              // Get models. models contains enums that can be used.
              let models = window['powerbi-client'].models;
              // We give All permissions to demonstrate switching between View and Edit mode and saving report.
              let permissions = models.Permissions.All;

              //Load the filters
              let filters: Array<any> = null;// = this.loadFilters();

              ////Create config 
            let config = {
              type: this.reportType,
              tokenType: models.TokenType.Embed,
              accessToken: this.reportToken,
              embedUrl: this.reportUrl,
              id: this.reportId,
              pageView: 'fitToWidth',
              permissions: permissions,
              settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: false
              },
              filters: filters
            }; 

           

               // Get a reference to the embedded report HTML element
               let embedContainer = jQuery('#embedContainer')[0];
               if (this.embeddedReport) {
                   powerbi.reset(embedContainer);
                   this.embeddedReport = powerbi.embed(embedContainer, config);
               }
               else {
                   this.embeddedReport = powerbi.embed(embedContainer, config);
               }
               if (!this.embeddedReport) {

                   this.reportVisible = false;

                }
                else{

                    // LOADED
                    let inst = this;
                    this.embeddedReport.off("loaded");
                    this.embeddedReport.on("loaded", function () {


                      console.log("Dashboard Loaded.");

                      inst.setTokenExpirationListener();




                    });

                     // RENDERED
                    this.embeddedReport.off("rendered");
                    this.embeddedReport.on("rendered", function () {


                        console.log("Dashboard Rendered.");



                    });

                   // DATA SELECTED
                    this.embeddedReport.off("dataSelected");
                    this.embeddedReport.on("dataSelected", function () {

                        console.log("Dashboard DataSelected.");


                    });

                   // ERROR
                    this.embeddedReport.off("error");
                    this.embeddedReport.on("error", function (e:any) {

                        console.log("Error-->loadReport(): " + e.detail.errorCode);

                        embedContainer = jQuery('#embedContainer')[0];
                        let loadedReport = powerbi.get(embedContainer);
                        loadedReport.off("error");



                    });
                }



        }
        catch (e) {
            console.log("Error-->loadReport(): " + e.message);

        }
    }

    //-----------------------------------------------
    // setTokenExpirationListener
    //-----------------------------------------------
    private setTokenExpirationListener() {
      // get current time
      var minutesToRefresh = 10;
      var currentTime = Date.now();
      var expiration: number = this.reportTokenExpiration;
      var safetyInterval = minutesToRefresh * 60 * 1000;

      // time until token refresh in milliseconds
      var timeout:any = expiration - currentTime - safetyInterval;

      // if token already expired, generate new token and set the access token
      let inst = this;
      if (timeout <= 0) {

        console.log("Updating Report Embed Token");
        inst.updateToken();

      }
      else { // set timeout so minutesToRefresh minutes before token expires, token will be updated
        timeout = 300000;
        let durationText = this.convertMS(timeout);
        console.log("Report Embed Token will be updated in " + durationText.hour + " hour(s), \n"   
                                                                                      + durationText.minute + " minutes(s), \n"
                                                                                      + durationText.seconds + " second(s)");
        setTimeout(function () {
          inst.updateToken();
        }, timeout);
      }
}

    //-----------------------------------------------
    // updateToken
    //-----------------------------------------------
  private updateToken() {
     

        // Generate new EmbedToken
      this.loadReportTokenSubscription = this.getReportToken().subscribe(data => {

        this.reportToken = JSON.parse(data).AccessToken;
        this.reportTokenExpiration = Date.parse(JSON.parse(data).TokenExpiration);

        let embedContainer = jQuery('#embedContainer')[0];
        if (embedContainer) {

          this.embeddedReport = powerbi.get(embedContainer);

          // Set AccessToken
          let inst = this;
          this.embeddedReport.setAccessToken(this.reportToken)
            .then(function () {
              // Set token expiration listener
              // result.expiration is in ISO format
              inst.setTokenExpirationListener( );
            });
        }


         },
        err => {
          console.log(err);


        });


    }


      //-----------------------------------------------
      // UpdateBusyControl
      //-----------------------------------------------
      private UpdateBusyControl() {

          let delay: number = 100;
          let minDuration: number = 900;

          this.busyLoading = {
              busy: [this.loadReportTokenSubscription, this.loadDashboardPermissionsSubscription],
              message: this.i18n.translate("busy-loading"),
              delay: delay,
              minDuration: minDuration
          };
      }
      //-----------------------------------------------
      // convertMS
      //-----------------------------------------------
      private convertMS(milliseconds) {
          var day, hour, minute, seconds;
          seconds = Math.floor(milliseconds / 1000);
          minute = Math.floor(seconds / 60);
          seconds = seconds % 60;
          hour = Math.floor(minute / 60);
          minute = minute % 60;
          day = Math.floor(hour / 24);
          hour = hour % 24;
          return {
            day: day,
            hour: hour,
            minute: minute,
            seconds: seconds
          };
  }



    //----------------------------------------------- 
    // getDashboardPermissions
    //-----------------------------------------------  
    private getDashboardPermissions(): Observable<any> {

      let headers = new Headers({ 'Accept': 'application/json' });
      let options = new RequestOptions({ headers: headers });

     return this.http.get('app/models/dashboard-permissions.json', options).map((res: Response) => res.json())


  }

  //----------------------------------------------- 
  // IsCrestronUser
  //-----------------------------------------------  
  private get IsCrestronUser(): boolean {
    let ret: boolean = false;
    if (this.hydUser && this.hydUser.Roles) {
      let isCrestronUser = this.hydUser.Roles.find(role => { return role.indexOf("Crestron") != -1; });
      if (isCrestronUser)
        ret = true;
    }
    return ret;
  }


 }

class Item  {
    label: string;
    value: any;
}

export class Report {
  public reportName: string
  public reportType: string
  public reportRoute: string;
  public reportId: string;
  public groupId: string;
  public accounts: string[];
  public label: string;
  public value: string;
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/powerbi-report-container/powerbi-report-container.component.ts